module.exports = __webpack_public_path__ + "static/img/clear_close.dad9dae.svg";


//////////////////
// WEBPACK FOOTER
// ./yotta-vue-components/vision/assets/clear_close.svg
// module id = UWc7
// module chunks = 3